import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import fr from 'facet-rest';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { metaOverrideSet } from './metaOverrideSet';


const ScenarioSelectionRedefinedStepContentHeader = ({ resource }) => {
  const lottieRel = resource.withRelationship(fr.relationships.lottie.name,
    (rel) => rel,
    () => null);

  // return null if content header will have no elements - this is to prevent a massive amount of spacing
  // between the progress stepper and the actual content
  if (!resource.attr('title') && !resource.attr('subtitle') && !resource.attr('body') && !lottieRel) {
    return null;
  }

  return (
    <FDStack direction="column" spacing={5} alignItems="center" width={'100%'}>
      <FDStack direction="column" spacing={5} alignItems="center" width={'100%'}>
        <LottieRel relationship={lottieRel} />
        <MetaControl resource={resource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={resource} attrName={'subtitle'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={resource} attrName={'body'} metaOverrideSet={metaOverrideSet} />
      </FDStack>
    </FDStack>
  );
};

ScenarioSelectionRedefinedStepContentHeader.defaultProps = {
};

ScenarioSelectionRedefinedStepContentHeader.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioSelectionRedefinedStepContentHeader;
